<template>
    <div class="container">
        <div class="search_box psr">
          <el-select v-model="is_bind" class="mr20">
            <el-option label="在院" value="1"></el-option>
            <el-option label="离院" value="2"></el-option>
          </el-select>
          <el-select v-model="bind_status" class="mr20" placeholder="请选择绑定状态">
            <el-option label="全部" value="0"></el-option>
            <el-option label="绑定中" value="1"></el-option>
            <el-option label="未绑定" value="2"></el-option>
          </el-select>
            <el-input v-model="bed_number" @keyup.enter.native="search" placeholder="请输入床位" class="mr20"></el-input>
            <el-input v-model="patient_id" @keyup.enter.native="search" placeholder="请输入患者住院号" class="mr20"></el-input>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button type="success" @click="reset">重置</el-button>
            <el-button type="warning" @click="pageTo">切换至实时体征监测模式</el-button>

            <div class="logo_box">
                <el-button class="ele_btn" type="danger" size="large" @click="openEleList" v-show="ele_total!=0">低电量提醒 <span class="num">{{
                    ele_total }}</span></el-button>
                <img src="../../assets/logo_2.png">
            </div>
           
        </div>
        <div class="table">
            <el-table :data="tableData" v-loading="table_loading" style="width: 100%">
                <el-table-column label="序号" align="center">
                    <template slot-scope="scope">{{ scope.$index }}</template>
                </el-table-column>
                <el-table-column label="所在病区" align="center" width="190">
                    <template slot-scope="scope">{{ scope.row.zone_name }}（{{ scope.row.zone_number }}）</template>
                </el-table-column>
                <el-table-column prop="bed_number" label="床位" align="center">
                </el-table-column>
                <el-table-column prop="ccid" label="设备编号" align="center" width="190">
                </el-table-column>
                <el-table-column prop="bind" label="设备状态" align="center" width="90">
                  <template slot-scope="scope">
                        <div>
                            {{ scope.row.bind==1?'绑定中':"未绑定" }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="patient_id" label="住院号" align="center">
                </el-table-column>
                <el-table-column prop="name" label="患者姓名" align="center">
                </el-table-column>
                <el-table-column prop="bind_time" label="佩戴开始时间" width="230" align="center">
                </el-table-column>
                <el-table-column label="心率预警阈值" align="center" width="160">
                    <template slot-scope="scope">
                        <div>
                            最低值{{ scope.row.low_heartrate_value }}bpm
                        </div>
                        <div>
                            最高值{{ scope.row.high_heartrate_value }}bpm
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="血氧预警阈值" align="center" width="300">
                    <template slot-scope="scope">
                        <div>
                            最低值{{ scope.row.spo2 }}%
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="ppg" label="表端采集频率" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.ppg }}分钟/次
                    </template>
                </el-table-column>
                <el-table-column prop="normal_rate" label="表端上传频率" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.normal_rate }}/次
                    </template>
                </el-table-column>
                <el-table-column label="离院预警" align="center" width="90">
                    <template slot-scope="scope">
                        <div class="circle">已开启</div>
                    </template>
                </el-table-column>
                <el-table-column label="SOS报警" align="center" width="90">
                    <template slot-scope="scope">
                        <div class="circle">已开启</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="160" fixed="right">
                    <template slot-scope="scope">
                        <div @click="printReport(scope.row)" class="printReport">
                            <img src="../../assets/print.png" alt="">
                            导出报告({{ scope.row.is_print == 1 ? '未打印' : "已打印" }})
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                    :page-sizes="[10, 15, 20, 25]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>

        <div class="print_box" v-show="showPrint">
            <div id="print_container">
                <div class="print_title">武汉同济{{ printObj.zone.zone_name }}病区{{ printObj.zone.bed_number }}床<br>护理服务报告
                </div>
                <table border="0" cellspacing="0">
                    <tr>
                        <td class="table_bg" style=" width:240px;">患者姓名</td>
                        <td>{{ print_name }}</td>
                    </tr>
                    <tr>
                        <td class="table_bg" style=" width:240px;">住院号</td>
                        <td>{{ printObj.zone.patient_id }}</td>
                    </tr>
                    <tr v-for="(item, index) in printObj.interval_time" :key="index">
                        <td class="table_bg" style=" width: 240px;">统计时间</td>
                        <td>
                            {{ item }}
                        </td>
                    </tr>
                    <tr>
                        <td class="table_bg" style=" width: 240px;">统计小时数</td>
                        <td>{{ printObj.interval_data }}</td>
                    </tr>
                </table>
                <div class="part_title">1、心率监测情况（住院期间）</div>
                <div class="part_text">平均心率为 {{ printObj.heartrate_average }} 次/分，最高心率 {{ printObj.heartrate_max }} 次/分，最低心率
                    {{ printObj.heartrate_min }} 次/分；</div>
                <div class="part_title">2、血氧监测情况（住院期间）</div>
                <div class="part_text">平均血氧为 {{ printObj.spo2_average }} %，最高血氧 {{ printObj.spo2_max }}%，最低血氧
                    {{ printObj.spo2_min }}%；</div>
                <div class="part_title">3、心率血氧整体区间分布（住院期间）</div>
                <table border="0" cellspacing="0" v-if="printObj.heartrate_section">
                    <tr>
                        <td class="table_bg" style=" width: 190px;">采集指标</td>
                        <td class="table_bg">分布区间</td>
                        <td class="table_bg" style=" width: 190px;">出现次数</td>
                        <td class="table_bg" style=" width: 170px;">占比</td>
                    </tr>
                    <tr>
                        <td rowspan="4">心率</td>
                        <td>心率＜45次/分</td>
                        <td>{{ printObj.heartrate_section['< 45'].number }}</td>
                        <td>{{ printObj.heartrate_section['< 45'].compare }}</td>
                    </tr>
                    <tr>
                        <td>45次/分≤心率≤80次/分</td>
                        <td>{{ printObj.heartrate_section['45 - 80'].number }}</td>
                        <td>{{ printObj.heartrate_section['45 - 80'].compare }}</td>
                    </tr>
                    <tr>
                        <td>80次/分≤心率≤120次/分</td>
                        <td>{{ printObj.heartrate_section['80 - 120'].number }}</td>
                        <td>{{ printObj.heartrate_section['80 - 120'].compare }}</td>
                    </tr>
                    <tr>
                        <td>心率＞120次/分</td>
                        <td>{{ printObj.heartrate_section['> 120'].number }}</td>
                        <td>{{ printObj.heartrate_section['> 120'].compare }}</td>
                    </tr>
                    <tr>
                        <td rowspan="4">血氧</td>
                        <td>血氧＜80%</td>
                        <td>{{ printObj.spo2_section['< 80'].number }}</td>
                        <td>{{ printObj.spo2_section['< 80'].compare }}</td>
                    </tr>
                    <tr>
                        <td>80%≤血氧＜90%</td>
                        <td>{{ printObj.spo2_section['80 - 90'].number }}</td>
                        <td>{{ printObj.spo2_section['80 - 90'].compare }}</td>
                    </tr>
                    <tr>
                        <td>90%≤血氧＜95%</td>
                        <td>{{ printObj.spo2_section['90 - 95'].number }}</td>
                        <td>{{ printObj.spo2_section['90 - 95'].compare }}</td>
                    </tr>
                    <tr>
                        <td>血氧＞95%</td>
                        <td>{{ printObj.spo2_section['> 95'].number }}</td>
                        <td>{{ printObj.spo2_section['> 95'].compare }}</td>
                    </tr>
                </table>
                <div v-if="printObj.interval_time && printObj.interval_time.length <= 2" class="print_page"></div>
                <div class="part_title">4、数据采集明细数据（住院期间）</div>
                <div v-for="(list,index) in this.printObj.data_list_l" :key="index" :class="{print_page:index!=0,table_padding:index!=0}">
                  <table border="0" cellspacing="0">
                    <thead>
                      <tr>
                          <th class="table_bg">采集指标</th>
                          <th class="table_bg">采集时分秒</th>
                          <th class="table_bg">心率采集结果</th>
                          <th class="table_bg">血氧采集结果</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in list" :key="i" >
                          <td>{{ $dateFtt.dateFtt('yyyy-MM-dd', new Date(item.insert_time * 1000)) }}</td>
                          <td>{{ $dateFtt.dateFtt('hh:00:00', new Date(item.insert_time * 1000)) }}</td>
                          <td>{{ item.heartrate }}（次/分）</td>
                          <td >{{ item.spo2 }}%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
               
            </div>
        </div>
        
        <el-dialog :visible.sync="ele_dialog" title="低电量提醒" width="900px">
            <div class="dialog_tips">请及时进行设备充电！</div>
            <el-table v-loading="dialogTableLoading" :key="tableKey" :data="dialogTableData" style="width: 100%; margin-bottom: 20px" border
                height="334px">
                <el-table-column align="center" prop="ccid" label="设备CCID" width="200px">
                </el-table-column>
                <el-table-column align="center" prop="bed_number" label="床号"> </el-table-column>
                <el-table-column align="center" prop="name" label="姓名"> </el-table-column>
                <el-table-column align="center" prop="bat" label="电量">
                    <template slot-scope="scope">
                        <div  style="color:red;">{{ scope.row.bat }}%</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="insert_time" label="电量同步时间" width="180px">
                    <template slot-scope="scope">
                        {{ scope.row.insert_time ? $dateFtt.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(scope.row.insert_time *
                            1000))
                            : '' }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" class="table_btn_primary" @click="editBatStatus(scope.row, scope.$index)"
                            size="small" v-show="scope.row.status !== 1">处理</el-button>
                        <el-button type="default" class="table_btn_primary" disabled size="small" v-show="scope.row.status == 1">已处理</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="pagination" @current-change="handleDialogCurrentChange" :page-sizes="[5]" :current-page="dialog_page"
                :page-size="5" layout="sizes,prev, pager, next,total" :total="dialog_total">
            </el-pagination>
        </el-dialog>
    </div>
</template>

<script>
import printCss from '../../assets/printcss'
export default {
    data() {
        return {
            is_bind:"1",
            bind_status:'1',
            tableData: [],
            patient_id: "",
            bed_number: "",
            patient_id: "",
            page: 1,
            limit: 10,
            total: 0,
            zone_number: "",
            printObj: {
                zone: {}
            },
            table_loading: false,
            showPrint: false,
            print_name:"",
            ele_total: 0,
            ele_dialog: false,
            dialogTableData: [],
            dialogTableLoading: false,
            dialog_total: 0,
            dialog_page: 1,
            tableKey:0,
            interval:""
        };
    },

    mounted() {
        this.checkLogin()
        this.zone_number = this.$cookies.get('zone_number')
        this.fetchData()
        this.fetchBatNum()
        this.interval = setInterval(() => {
            this.fetchBatNum()
        }, 600000);
    },
    beforeDestroy() {
        clearInterval(this.interval)
    },
    methods: {
        fetchBatNum() {
            let data = {
                zone_number: this.zone_number,
                page: this.dialog_page,
                perPage: 5
            }
            this.$http({
                url: '/api/hope/bat',
                method: "GET",
                params: data,
                headers: {
                    'Token': this.$cookies.get('token')
                }
            }).then(res => {
                this.ele_total = res.result.total
            })
        },
        editBatStatus(item, index) {
            this.dialogTableLoading = true
            let data = { id: item.id }
            this.$http({
                url: '/api/hope/bat_status',
                method: "POST",
                data: data,
                headers: {
                    'Token': this.$cookies.get('token')
                }
            }).then(res => {
                this.dialogTableLoading = false
                this.dialogTableData[index].status = 1
                this.$nextTick(()=>{
                    this.tableKey++
                })
                this.fetchBatNum()
            })
        },
        handleDialogCurrentChange(e) {
            this.dialog_page = e
            let data = {
                zone_number: this.zone_number,
                page: this.dialog_page,
                perPage: 5
            }
            this.dialogTableLoading = true
            this.$http({
                url: '/api/hope/bat',
                method: "GET",
                params: data,
                headers: {
                    'Token': this.$cookies.get('token')
                }
            }).then(res => {
                this.dialogTableLoading = false
                this.dialogTableData = res.result.data
                this.dialogTableData.forEach((item,index) => {
                    this.dialogTableData[index].status=0
                });
                this.dialog_total = res.result.total
            })
        },
        openEleList() {
            this.dialog_page = 1
            let data = {
                zone_number: this.zone_number,
                page: this.dialog_page,
                perPage: 5
            }
            this.dialogTableLoading = true
            this.$http({
                url: '/api/hope/bat',
                method: "GET",
                params: data,
                headers: {
                    'Token': this.$cookies.get('token')
                }
            }).then(res => {
                this.dialogTableLoading = false
                this.dialogTableData = res.result.data
                this.ele_dialog = true
                this.dialog_total = res.result.total
                this.dialogTableData.forEach((item,index) => {
                    this.dialogTableData[index].status=0
                });
            })
        },
        checkLogin() {
            if (!this.$cookies.get('token')) {
                this.$router.push('/login')
            }
        },
        pageTo() {
            this.$router.push({
                path: '/all_device_data',
                query: {
                    zone_number: this.zone_number
                }
            })
        },
        printReport(item) {
            let data = {
                ccid: item.ccid,
                start: item.start,
                end: item.end,
                patient_id: item.patient_id, 
                zone_number: this.zone_number,
                id: item.id
            }
            this.print_name=item.name
            this.checkLogin()

            this.$http({
                url: 'api/output/signDateReport',
                method: "GET",
                params: data,
                headers: {
                    'Token': this.$cookies.get('token')
                }
            }).then(res => {
                this.printObj = res.result
                this.printObj.zone = item

                let data_list = []
                for (const key in this.printObj.data_list) {
                  if (Object.hasOwnProperty.call(this.printObj.data_list, key)) {
                    const element = this.printObj.data_list[key];
                    data_list.push(element)
                  }
                }
                this.printObj.data_list_l=[]
                for (let index = 0; index < Math.ceil(data_list.length/20); index++) {
                  this.printObj.data_list_l[index]=[]
                  
                }
              
                data_list.forEach((item,index)=>{
                  this.printObj.data_list_l[Math.floor((index)/20)].push(item)
                })

                console.log( this.printObj.data_list_l);

                this.$nextTick(() => {
                    this.printFn()
                    this.fetchData()
                })
            })
        },
        printFn() {
            const printContent = document.querySelector('#print_container').innerHTML;
            const iframe = document.createElement('iframe');
            iframe.setAttribute('style', 'position: absolute; width: 0; height: 0;'); document.body.appendChild(iframe);
            const iframeDoc = iframe.contentWindow.document;
            iframeDoc.write('<div id="print_container">' + printContent + '</div>');
            iframeDoc.write(`<style media="print">${printCss}</style>`);
            setTimeout(function () {
                iframe.contentWindow.print();
                document.body.removeChild(iframe);
            }, 50)
        },
        handleSizeChange(e) {
            this.limit = e
            this.fetchData()
        },
        handleCurrentChange(e) {
            this.page = e
            this.fetchData()
        },
        search() {
            this.limit = 10
            this.page = 1
            this.fetchData()
        },
        reset() {
            this.limit = 10
            this.page = 1
            this.bed_number = ''
            this.patient_id = ''
            this.bind_status = '1'
            this.is_bind='1'
            this.fetchData()
        },
        fetchData() {
            this.table_loading = true
            this.checkLogin()

            this.$http({
                url: 'api/output/signDate',
                method: "GET",
                params: {
                    page: this.page, 
                    limit: this.limit,
                    bed_number: this.bed_number, 
                    zone_number: this.zone_number,
                    patient_id: this.patient_id,
                    is_bind:this.is_bind,
                    bind_status:this.bind_status
                },
                headers: {
                    'Token': this.$cookies.get('token')
                }
            }).then(res => {
                // console.log(res);
                this.table_loading = false
                // let deleteIndex = []
                // arr.sort((a, b) => {
                //     return a.id - b.id
                // })
                // // console.log(this.tableData);
                // arr.forEach((item, index) => {
                //     arr.forEach((e, i) => {
                //         if (item.bed_number == e.bed_number && item.id != e.id) {
                //             deleteIndex.push(index)
                //         }
                //     })
                // })
                // deleteIndex.length = deleteIndex.length / 2
                // deleteIndex.forEach((item, index) => {
                //     arr.splice(item - index, 1)
                // // })
                // let arr = res.result.data
                // arr.sort((a, b) => {
                //     return b.id - a.id
                // })
                // this.tableData = this.removeSame5(arr, 'bed_number').sort((a, b) => {
                //     return a.id - b.id
                // })
                this.tableData = res.result.data
                this.total = res.result.total
            })
        },
        removeSame5(arr, prop) {
            // console.log(arr);
            let newArr = [];  // 去重后得到的新数组
            const obj = {};  //  中间值 转换数据
            newArr = arr.reduce(function (pre, cur) {
                obj[cur[prop]] ? '' : (obj[cur[prop]] = true && pre.push(cur));
                return pre;
            }, []);
            return newArr;
        }
    }
}

</script>
<style  scoped>
.search_box {
    padding: 20px 0;
}

.search_box>>>.el-input {
    width: 180px;
}

.mr20 {
    margin-right: 20px;
}

.table>>>.el-table th.el-table__cell {
    background-color: #EDF3FF;
    color: #252B50;
}

.block {
    text-align: right;
    margin-top: 20px;
}

.circle {
    font-size: 14px;
    color: #07C160;
    position: relative;
}

.circle::before {
    position: absolute;
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 8px;
    background-color: #07C160;
    left: 0;
    top: 7px;
}

.printReport {
    font-size: 14px;
    color: #6377F5;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
}

.printReport img {
    position: absolute;
    /* width: 20px; */
    width: auto;
    height: 18px;
    top: 2px;
    left: 0;
}



.logo {
    position: absolute;
    right: 70px;
    top: 50px;
    width: 140px;
    opacity: .4;
}

.fix_phone {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 18px;
    height: 40px;
    line-height: 40px;
    padding: 0 40px;
    background-color: #409EFF;
    color: #ffffff;
    border-bottom-left-radius: 10px;
}

.psr {
    position: relative;
}


.logo_box {
    height: 40px;
    /* width: auto; */
    position: absolute;
    right: 20px;
    top: 20px;
}

.logo_box img {
    height: 100%;
    width: auto;
    vertical-align: top;
}

.ele_btn {
    /* position: absolute; */
    margin-right: 20px;
}

.logo_box>>>.el-button--danger {
    background-color: red !important;
    border-color: red !important;
    padding-right: 50px;
    position: relative;
}

.num {
    position: absolute;
    top: 10px;
    right: 20px;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    background-color: #fff;
    color: red;
    text-align: center;
    line-height: 20px;
    font-weight: bold;
}
.pagination {
    text-align: center;
}

.dialog_tips {
    font-size: 16px;
    margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/device_list.vue